/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Indexnow_DescriptionInputs */

const en_admin_indexnow_description = /** @type {(inputs: Admin_Indexnow_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tell Bing, Yandex and other IndexNow search engines about new or changed pages right away instead of waiting for their crawlers.`)
};

/**
* | output |
* | --- |
* | "Tell Bing, Yandex and other IndexNow search engines about new or changed pages right away instead of waiting for their crawlers." |
*
* @param {Admin_Indexnow_DescriptionInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_indexnow_description = /** @type {((inputs?: Admin_Indexnow_DescriptionInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Indexnow_DescriptionInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_indexnow_description(inputs)
});
export { admin_indexnow_description as "admin.indexnow.description" }